export default function ({ $axios }, inject) {
  // const rwigo = $axios.create();
  // inject('rwigo', rwigo);
}
